var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartOutlineLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHeartOutlineLS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.0453052,42.1591789 C48.3166696,45.0367313 48.3197941,49.6561452 51.0453052,52.5359745 L62.174512,64.2975921 C62.2838104,64.4140297 62.4358496,64.48 62.5949008,64.48 C62.7539519,64.48 62.9059911,64.4140297 63.0152895,64.2975921 C66.7285739,60.3816105 70.4402099,56.4611685 74.1535232,52.5450996 C76.8821589,49.6674976 76.8821589,45.0458884 74.1535232,42.1682893 C71.4249165,39.2906932 66.9644441,39.290629 64.2358084,42.1682893 L62.5994139,43.8901661 L60.9630484,42.1591789 C59.598716,40.7203793 57.7958845,40 55.9996491,40 C54.2034138,40 52.4096086,40.7203764 51.0453052,42.1591789 Z M56.3026124,41.3486403 C57.7064144,41.3486403 59.1707165,42.3173758 60.2578071,43.4638036 L62.2063167,45.5220638 C62.3096355,45.6321393 62.4533616,45.6945056 62.6037169,45.6945056 C62.7540723,45.6945056 62.8977984,45.6321393 63.0011172,45.5220638 L65.1188721,43.0326215 C67.9144369,40.4038785 71.2843749,41.1709507 73.4585287,43.4638036 C75.6326552,45.7566538 74.9006999,49.4728845 72.7265734,51.7657374 C69.3500319,55.3266274 65.9759512,58.8923677 62.5994371,62.4532027 L52.4723286,51.7571392 C50.2997883,49.4615856 49.7575439,45.3254221 51.9316976,43.0326215 C53.0187609,41.8861964 54.8988103,41.3486403 56.3026124,41.3486403 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-49.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icHeartOutlineLS",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartOutlineLs);
export default __webpack_public_path__ + "static/media/icHeartOutlineLS.e5d1e8f186b08250025800351bd03380.svg";
export { ForwardRef as ReactComponent };